import React, { Component } from "react";
import { connect } from "react-redux";
import Table from "../table/Table";
import Paginater from "../table/Paginater";
import moment from "moment";
import {
  fetchStockOrdersList,
  getOrderDetailsForPage,
  archiveStockOrder,
  printStockOrder,
} from "../../homeActions";
import { openModal } from "../../../modal/modalActions";
import { Tag, Button } from "antd";
import MobileOrderActions from "../MobileOrderActions";
import { renderLnamCell } from "../table/orderTableCells";
class StockOrdersTab extends Component {
  state = {};
  componentDidMount() {
    // if (this.props.activeTabKey === "5") {
    // this.props.fetchStockOrdersList();
    //}
  }
  columns = [
    {
      title: "Order No.",
      dataIndex: "internal_order_id",
      sorter: (a, b) => a.internal_order_id - b.internal_order_id,
      sortDirections: ["ascend"],
      render: (text, record, index) => (
        <p
          className="validate-link"
          onClick={() => this.props.getOrderDetailsForPage(record.id, index)}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Reference Id",
      dataIndex: "reference_id",
    },
    {
      title: "External Order Id",
      dataIndex: "external_order_id",
      mobileHidden: true,
    },
    {
      title: "Entry Date & Time",
      dataIndex: "received_date",
      render: (text) => {
        if (text !== null) {
          return <p>{moment(text).format("YYYY-MM-DD HH:mm")}</p>;
        }
      },
    },
    {
      title: "Coating",
      dataIndex: "coating.value",
      mobileHidden: true,
    },
    {
      title: "LNAM",
      dataIndex: "lnam.name",
      mobileHidden: true,
      render: renderLnamCell,
    },
    {
      title: "Customer",
      dataIndex: "customer.name",
      mobileHidden: true,
    },
    {
      title: "Promise Date & Time",
      dataIndex: "promised_date",
      mobileHidden: true,
      render: (text) => {
        if (text !== null) {
          return <p>{moment(text).format("YYYY-MM-DD HH:mm")}</p>;
        }
      },
    },
    {
      title: "Labels",
      width: 150,
      mobileHidden: true,
      render: (text, record) => {
        return (
          <div>
            {record.label.length > 0 &&
              record.label.map((item, index) => {
                return (
                  <Tag color="blue" key={index}>
                    {item.label.short_code}
                  </Tag>
                );
              })}
          </div>
        );
      },
    },
    {
      title: "Actions",
      fixed: "right",
      width: 200,
      className: "order-actions-column",
      render: (text, record) => {
        return (
          <MobileOrderActions>
            <Button
              className="order-action-btn"
              size="small"
              type="primary"
              onClick={this.handleLabelModal(record.id)}
            >
              Add Label
            </Button>
          </MobileOrderActions>
        );
      },
    },
  ];
  handleLabelModal = (id) => () => {
    this.props.openModal("CreateLabelModal", { id });
  };
  handleOrderPrint = (id) => () => {
    window.print();
    this.props.printStockOrder(id);
  };
  render() {
    const { loading, orders, fetchStockOrdersList } = this.props;
    return (
      <div>
        <Table
          columns={this.columns}
          loading={loading}
          data={(orders && orders.results) || []}
          pagination={false}
          bordered={false}
          size="middle"
        />
        <Paginater
          defaultCurrent={1}
          total={(orders && orders.count) || 0}
          onChange={fetchStockOrdersList}
          pageSize={20}
        />
      </div>
    );
  }
}
const actions = {
  fetchStockOrdersList,
  getOrderDetailsForPage,
  archiveStockOrder,
  printStockOrder,
  openModal,
};
const mapStateToProps = (state) => ({
  loading: state.home.loadingStockOrders,
  orders: state.home.stockOrders,
  activeTabKey: state.home.activeTabKey,
});
export default connect(
  mapStateToProps,
  actions
)(StockOrdersTab);
